export interface PermissionDiff {
  added: string[]
  removed: string[]
}

export function diffPermissions(
  saved: readonly string[],
  next: readonly string[],
): PermissionDiff {
  return {
    added: next.filter((scope) => !saved.includes(scope)).sort(),
    removed: saved.filter((scope) => !next.includes(scope)).sort(),
  }
}

export function hasPermissionChanges({ added, removed }: PermissionDiff) {
  return added.length > 0 || removed.length > 0
}
